import Layout from '../../components/layouts/AppLayout'
import Head from 'next/head'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { withToken } from '../../services/client'
import { GET_PAGE } from '../../services/graphql/queries/getPage'
import Error from 'next/error'
import { useMemo } from 'react'
import CmsComponent from '../../components/CmsComponent'
import sellerOnlyPages from '../../services/sellerOnlyPages'
import DeveloperLayout from '../../components/layouts/DeveloperLayout'

export default function Page ({ page }) {
  if (!page) {
    return <Error statusCode={404}/>
  }

  const fields = useMemo(() => page.attributes)

  const content = (
    <>
      <Head>
        <title>
          {fields.SEO?.MetaTitle || fields.title}
        </title>
        <meta
          name="description"
          content={fields.SEO?.MetaDescription || ''}
        />
        {
          fields.SEO?.MetaTag.map((tag, index) => {
            const isOg = (typeof tag.Name === 'string') && tag.Name.includes('og:')

            return (
              <meta
                key={index}
                {...(isOg ? { property: tag.Name } : { name: tag.Name })}
                content={tag.Content}
              />
            )
          })
        }
      </Head>
      <div className="container pb-5">
        {
          fields.block.map((block, index) => (
            <CmsComponent
              typename={block.__typename}
              props={block}
              index={index}
              key={index}
            />
          ))
        }
      </div>
    </>
  )

  return (
    <>
      {
        fields.LayoutType === 'Developer'
          ? <DeveloperLayout
              classNameContent="bg-light cms"
            >
            {content}
          </DeveloperLayout>
          : <Layout
              classNameContent="bg-light cms"
            >
            {content}
          </Layout>

      }
    </>
  )
}

export async function getServerSideProps ({ locale, query: { slug } }) {
  const { isSellerOnlyPage } = sellerOnlyPages()

  let page = false

  if (isSellerOnlyPage(slug)) {
    return {
      props: {
      }
    }
  }

  try {
    const { data } = await withToken(process.env.NEXT_PUBLIC_CMS_PUBLIC_TOKEN, locale, process.env.NEXT_PUBLIC_CMS_GRAPHQL_URL).query({
      query: GET_PAGE,
      fetchPolicy: 'no-cache',
      variables: {
        slug,
        locale
      }
    })

    page = data.pages.data.length ? data.pages.data[0] : false
  } catch (e) {
    console.log(e.networkError.result)
  }

  return {
    props: {
      page,
      ...(await serverSideTranslations(locale, ['header', 'footer', 'languages', 'applications', 'routes']))
    }
  }
}
